import { React, useState } from 'react'
import { Grid, Card, CardContent } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { ButtonSuccess } from '../../shared/components/ButtonSucces';
import ContactForm from './ContactForm';
import AntDataGrid from './../../shared/components/AntDataGrid';
import { useFirestoreConnect } from 'react-redux-firebase'
import { useSelector } from 'react-redux'
import { useMemo } from 'react';
import { EnhancedTableToolbar } from './ExportToolBar';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import SendIcon from '@mui/icons-material/Send';
import Stack from '@mui/material/Stack';
import readXlsxFile from 'read-excel-file'
import useToggle from "../../shared/functions/useToggle";
import ContactEditForm from "./ContactEditForm";
import {Popconfirm} from "antd";
import {firestore} from "../../config/firebaseConfig";
import {toast} from "react-toastify";
//import { cvsReader } from './../../shared/functions/cvsReader';
// import { arrayOf } from 'prop-types';



const schema = {
    'Phone Number' : {
        prop: 'Phone Number',
        type: 'number',
        required: true
    } ,
    'Nom article' : {
        prop: 'Nom article',
        type: 'string',
        // required: true
    }
}


const Input = styled('input')({
    display: 'none',
});
const ContactList = () => {
    const [modalState, setModalState] = useState(false);
    const [selected, setSelected] = useState();
    const {open, handleOpen, handleClose} = useToggle()

    // const [fileName, setFileName] = useState('');
    function handleDelete(key) {
        let contactRef = firestore.collection('contacts').doc(key)
        contactRef.delete().then(() => {
            toast.success("Document successfully deleted!");
        }).catch((error) => {
            toast.error("Error removing document ");
        });

    }

    const columns = [
        { title: 'Name', dataIndex: 'Name', key: 'Name'},
        { title: 'Compagny', dataIndex: 'Compagny', key: 'Compagny'},
        { title: 'Tel', dataIndex: 'Tel', key: 'Tel'},
        { title: 'Adresse', dataIndex: 'Adresse', key: 'Adresse'},
        { title: 'Post', dataIndex: 'Post', key: 'Post'},
        { title: 'Code', dataIndex: 'Code', key: 'Code'},
        { title: 'Region', dataIndex: 'Region', key: 'Region'},
        { title: 'Ville', dataIndex: 'Ville', key: 'Ville'},
        { title: 'Pays', dataIndex: 'Pays', key: 'Pays'},
        { title: 'Email', dataIndex: 'Email', key: 'Email'},
        { title: 'Site', dataIndex: 'Site', key: 'Site' },


        {
            title: 'Action',
            dataIndex: 'Delete',
            render: (_, record) =>

                <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(record.key)}>
                    <Button>Deletee</Button>
                </Popconfirm>

        },]

    const handleCancel = () => {
        setModalState(false);
    }
    const handleOpenAdd = () => {
        setModalState(true);
    }

    useFirestoreConnect([
        {
            collection: 'contacts',
            storeAs: "contact"
        }
    ])

    const contactSelector = useSelector((state) => state.firestore.ordered.contact)
    const contact = useMemo(() => contactSelector?.map(one => ({ key: one.id, ...one })) || [], [contactSelector])

    const handleFileSelected = (event) =>{
        const file = event.target.files[0];

        if(file.name.includes('csv')){

           //const  arr = [];
            // file.forEach(function(item){
            //     arr.push(item)
            //     cvsReader({ file: arr, onChange:(result) => console.log('result', result)})
            //     return ;
            // })
          
        }
        if (file.name.includes('vcf')){
            console.log('vCard File')
        }

        readXlsxFile(file, (schema)).then((rows) => {
            const uniqueArray = [];

            rows.forEach((col)=>{
                col.forEach((file)=>{
                if(uniqueArray.indexOf(file) ===-1 && file !== '') {
                    uniqueArray.push(file)
                    console.log(uniqueArray.slice(0,5))
                    }
                })
                
            return uniqueArray;
            
        })

        }).catch(e => console.log('error', e))
        
    };

    // let csvData = [];
    //       let lbreak = file.split("\n");
    //       lbreak.forEach(res => {
    //           csvData.push(res.split(","));
    //       });

    //       console.table(csvData);
    //     }).catch(e => console.log('error', e))


    const handleEdit = (record) => {
        setSelected(record)
        handleOpen();
    };
    const handleEditModalClosing =() =>{
        setSelected(null)
        handleClose()
    }

    return (
        <div>

            {modalState && <ContactForm visible={modalState} handleCancel={handleCancel} contactSelector={contactSelector} />}
            {selected && <ContactEditForm visible={open} item={selected}  onClose={handleEditModalClosing} />}

            <Card>
                <CardContent>
                    <Grid container justify="space-between">
                        <Grid item >
                            <Stack direction="row" alignItems="center" spacing={2}>
                                <label htmlFor="contained-button-file">
                                    <Input accept="file/*" id="contained-button-file"  type="file" onChange={handleFileSelected} />
                                    <Button variant="contained" component="span" endIcon={<SendIcon />}>
                                        Importer les contacts
                                    </Button>    
                                </label>
                            </Stack>
                        </Grid>
                        <Grid item >
                            <ButtonSuccess size="small"
                                variant="contained"
                                color="primary"
                                onClick={handleOpenAdd}
                                startIcon={<AddIcon />}
                            >
                                Ajouter un Contact
                            </ButtonSuccess>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
            <Card>
                <CardContent >
                    <AntDataGrid
                        columns={columns}
                        data={contact}
                        ToolBar={EnhancedTableToolbar}
                        doubleClickAction={handleEdit}
                    />
                </CardContent>
            </Card>
        </div>
    )
}

export default ContactList